import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { createLink } from '@tanstack/react-router';

import { Button } from '../../button';

const LinkButton = createLink(Button);

const ErrorIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width='121'
      height='121'
      viewBox='0 0 121 121'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3135_96733)'>
        <path
          d='M112.5 4.12476H8.5C5.1875 4.12476 2.5 6.81226 2.5 10.1248V90.3748C2.5 93.6873 5.1875 96.3748 8.5 96.3748H51L46.255 113.855C55.7993 112.519 65.6305 112.57 74.9325 113.882L70 96.3748H112.5C115.813 96.3748 118.5 93.6873 118.5 90.3748V10.1248C118.5 6.81226 115.813 4.12476 112.5 4.12476Z'
          fill={theme.palette.secondary[100]}
        />
        <path
          d='M118.5 10.1248V83.8748H2.5V10.1248C2.5 6.81226 5.1875 4.12476 8.5 4.12476H112.5C115.813 4.12476 118.5 6.81226 118.5 10.1248Z'
          fill={theme.palette.primary[50]}
        />
        <path
          d='M118.5 10.1248C118.5 13.7145 115.59 16.6248 112 16.6248H83.25C45.5565 16.6248 15 52.1813 15 89.8748C15 93.4645 12.0898 96.3748 8.5 96.3748C5.18625 96.3748 2.5 93.6885 2.5 90.3748V10.1248C2.5 6.81101 5.18625 4.12476 8.5 4.12476H112.5C115.814 4.12476 118.5 6.81101 118.5 10.1248Z'
          fill={theme.palette.secondary[100]}
        />
        <path
          d='M72.1126 103.875H48.9651L51.0001 96.3748H70.0001L72.1126 103.875Z'
          fill={theme.palette.primary[50]}
        />
        <path
          d='M118.5 83.8748V90.3748C118.5 93.6873 115.813 96.3748 112.5 96.3748H8.5C5.1875 96.3748 2.5 93.6873 2.5 90.3748V83.8748H118.5Z'
          fill={theme.palette.primary[50]}
        />
        <path
          d='M15.2575 83.8748C15.0875 85.8648 15 87.8673 15 89.8748C15 93.4648 12.09 96.3748 8.5 96.3748C5.1875 96.3748 2.5 93.6873 2.5 90.3748V83.8748H15.2575Z'
          fill={theme.palette.secondary[100]}
        />
        <path
          d='M118.5 74.9473C119.604 74.9473 120.5 74.0518 120.5 72.9473V10.1248C120.5 5.71351 116.911 2.12476 112.5 2.12476H8.5C4.08875 2.12476 0.5 5.71351 0.5 10.1248V90.3748C0.5 94.786 4.08875 98.3748 8.5 98.3748H112.5C116.996 98.3748 120.5 94.6775 120.5 90.4335V83.8748C120.5 82.7703 119.604 81.8748 118.5 81.8748H17.4597C16.3552 81.8748 15.4598 82.7703 15.4598 83.8748C15.4598 84.9793 16.3552 85.8748 17.4597 85.8748H116.5V90.3748C116.5 92.5803 114.705 94.3748 112.5 94.3748H8.5C6.2945 94.3748 4.5 92.5803 4.5 90.3748V10.1248C4.5 7.91926 6.2945 6.12476 8.5 6.12476H112.5C114.705 6.12476 116.5 7.91926 116.5 10.1248V72.9475C116.5 74.052 117.396 74.9473 118.5 74.9473Z'
          fill={theme.palette.primary[600]}
        />
        <path
          d='M89.0943 114.965C85.1383 113.734 80.9058 112.774 76.5053 112.092L74.1755 103.822C73.876 102.759 72.7705 102.14 71.7083 102.439C70.645 102.739 70.026 103.843 70.3255 104.906L72.1883 111.519C64.708 110.691 56.785 110.636 48.812 111.519L50.6918 104.846C50.9913 103.783 50.3723 102.678 49.309 102.379C48.2468 102.079 47.141 102.698 46.8418 103.761L44.495 112.092C40.0958 112.774 35.8633 113.734 31.906 114.965C30.8513 115.293 30.2625 116.414 30.5905 117.469C30.9185 118.524 32.0398 119.113 33.0945 118.784C49.7433 113.605 71.2583 113.605 87.906 118.784C88.9563 119.111 90.0805 118.528 90.41 117.469C90.7378 116.414 90.149 115.293 89.0943 114.965Z'
          fill={theme.palette.primary[600]}
        />
        <path
          d='M39.9961 41.6205C40.7776 42.4018 42.0434 42.4015 42.8246 41.6205L45.3261 39.119L47.8276 41.6205C48.6091 42.4018 49.8749 42.4015 50.6561 41.6205C51.4371 40.8395 51.4371 39.5733 50.6561 38.7923L48.1546 36.2908L50.6561 33.7893C51.4371 33.0083 51.4371 31.742 50.6561 30.961C49.8749 30.18 48.6089 30.18 47.8276 30.961L45.3261 33.4625L42.8249 30.9605C42.0436 30.1795 40.7776 30.1795 39.9964 30.9605C39.2154 31.7415 39.2154 33.0078 39.9964 33.7888L42.4979 36.2903L39.9964 38.7918C39.2151 39.573 39.2151 40.8395 39.9961 41.6205Z'
          fill={theme.palette.primary[600]}
        />
        <path
          d='M81.0038 30.9605C80.2226 30.1795 78.9566 30.1795 78.1753 30.9605L75.6738 33.462L73.1723 30.9605C72.3911 30.1795 71.1251 30.1795 70.3438 30.9605C69.5628 31.7415 69.5628 33.0078 70.3438 33.7888L72.8453 36.2903L70.3438 38.7918C69.5628 39.5728 69.5628 40.839 70.3438 41.62C71.1253 42.4013 72.3911 42.401 73.1723 41.62L75.6738 39.1185L78.1753 41.62C78.9568 42.4013 80.2226 42.401 81.0038 41.62C81.7848 40.839 81.7848 39.5728 81.0038 38.7918L78.5023 36.2903L81.0038 33.7888C81.7848 33.008 81.7848 31.7415 81.0038 30.9605Z'
          fill={theme.palette.primary[600]}
        />
        <path
          d='M46.727 64.8022C48.0728 63.482 53.0425 59.1747 60.5 59.1747C62.3853 59.1747 68.9503 59.5807 74.273 64.8025C75.0593 65.5737 76.3258 65.566 77.1013 64.7755C77.8748 63.987 77.8628 62.7207 77.0743 61.9472C68.0858 53.1295 53.3135 52.737 43.9258 61.9472C43.1373 62.7207 43.1253 63.987 43.8988 64.7755C44.6728 65.5642 45.939 65.5755 46.727 64.8022Z'
          fill={theme.palette.primary[600]}
        />
      </g>
      <defs>
        <clipPath id='clip0_3135_96733'>
          <rect
            width='120'
            height='120'
            fill='white'
            transform='translate(0.5 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const ErrorDisplay = ({ error }: { error: Error }) => {
  const isPlatformError = error.name === 'PlatformError';
  const isPermissionError = error.name === 'PermissionError';

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      width='100%'
      height='100dvh'
      gap={2.5}
    >
      <Box>
        <ErrorIcon />
      </Box>

      <Box textAlign='center'>
        <Typography variant='h6' component='h1' color='text.primary'>
          {error.name}
        </Typography>
        <Typography variant='body2' pt={0.75}>
          {error.message}
        </Typography>
      </Box>
      {isPlatformError || isPermissionError ? (
        <LinkButton to='/auth/logout'>Logout</LinkButton>
      ) : (
        <LinkButton to='/'>Return to Dashboard</LinkButton>
      )}
    </Stack>
  );
};

export default ErrorDisplay;
